import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import ActionTable from "../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import { formatDateTime, mergeParams } from "../../helpers/helpers";
import AppContext from "../../container/context";

const today = new Date();
const primeiroDia = new Date(today.getFullYear(), today.getMonth(), 1)
  .toISOString()
  .split("T")[0];
const diaAtual = today.toISOString().split("T")[0];
// const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
// const firstDayDate = firstDay.toLocaleDateString();

export default function Lista({ history, location }) {
  const { notification } = useContext(AppContext);

  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        dataInicio: primeiroDia,
        dataFim: diaAtual,
        destinatario: "",
        escolaId: 0,
        pagamentosEmAberto: false,
      },
      location
    )
  );

  const [lista, setLista] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [comboEscolas, setComboEscolas] = useState([]);

  useEffect(() => {
    carregar();
    carregarComboEscolas();
  }, []);

  const carregar = (filtrosEnviar = filtros) => {
    if (!filtrosEnviar.dataInicio)
      return notification("warning", "Selecione uma data de início");
    if (!filtrosEnviar.dataFim)
      return notification("warning", "Selecione uma data de início");

    setFiltros(filtrosEnviar);
    setCarregando(true);
    console.log("filtrosEnviar", filtrosEnviar);
    api.get("faturas/listarEnviosEmails", filtrosEnviar).then((res) => {
      res.forEach((r) => {
        r.fatura = (
          <p>
            {r.faturaVencimentoMes}/{r.faturaVencimentoAno}
          </p>
        );
        r.sucesso = !r.faturaEnvioEmailErro ? "Sim" : "Não";
        r.faturaEnvio = formatDateTime(r.faturaEnvioEmailEnvio, "D/M/Y h:m");
      });
      setLista(res);
      setCarregando(false);
    });
  };

  const carregarComboEscolas = () => {
    api.get("escolas/listar", { ativas: true }).then((escolas) => {
      setComboEscolas(escolas);
    });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      dataInicio: {
        label: "Início do período",
        type: "date",
        space: 6,
        value: filtros.dataInicio,
      },
      dataFim: {
        label: "Fim do período",
        type: "date",
        space: 6,
        value: filtros.dataFim,
      },
      destinatario: {
        label: "Email do destinatário",
        type: "text",
        space: 6,
        value: filtros.destinatario,
      },
      escolaId: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        space: 6,
        value: filtros.escolaId,
      },
      pagamentosEmAberto: {
        label: "Faturas com pagamento em aberto",
        type: "check",
        space: 6,
        value: filtros.pagamentosEmAberto,
      },
    },

    submit: {
      label: "Buscar",
      action: carregar,
    },

    urlParams: true,
    history,
    location,
  };

  const tRegistros = {
    title: "Emails enviados",
    onLineClick: (item) =>
      history.push(`/app/financeiro-envios-emails/${item.faturaEnvioEmailId}`),

    columns: [
      {
        label: "Enviado em",
        name: "faturaEnvio",
      },
      {
        label: "Fatura",
        name: "fatura",
      },
      {
        label: "Título",
        name: "faturaEnvioEmailTitulo",
      },
      {
        label: "Destinário",
        name: "faturaEnvioEmailDestinatario",
      },
      {
        label: "Escola",
        name: "escolaNomeFantasia",
      },
      {
        label: "Enviado com sucesso",
        name: "sucesso",
      },
    ],
    array: lista,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
